<h1 mat-dialog-title>Terminzyklus anlegen</h1>
<div mat-dialog-content>
  <form class="add-form">
    <form [formGroup]="cycleForm">
      <markant-input ngDefaultControl formControlName="name" label="Bezeichnung"></markant-input>
      <markant-textarea ngDefaultControl formControlName="description" label="Beschreibung" autogrow="true"></markant-textarea>

      <h4>Bewerbungszeitraum</h4>
      <div>
        <mat-form-field>
          <input formControlName="applicationStart" matInput [matDatepicker]="picker1" placeholder="Bewerbung Start" />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        &nbsp;-&nbsp;
        <mat-form-field>
          <input formControlName="applicationEnd" matInput [matDatepicker]="picker2" placeholder="Bewerbung Ende" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
      <h4>Voting</h4>
      <div>
        <mat-form-field>
          <input formControlName="votingStart" matInput [matDatepicker]="picker3" placeholder="Voting Start" />
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
        &nbsp;-&nbsp;
        <mat-form-field>
          <input formControlName="votingEnd" matInput [matDatepicker]="picker4" placeholder="Voting Ende" />
          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
          <mat-datepicker #picker4></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <input formControlName="feedback" matInput [matDatepicker]="picker8" placeholder="Feedback bis" />
          <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
          <mat-datepicker #picker8></mat-datepicker>
        </mat-form-field>
      </div>
      <h4>Pitch</h4>
      <mat-form-field>
        <input formControlName="pitchDate" matInput [matDatepicker]="picker5" placeholder="Pitch Termin" />
        <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
        <mat-datepicker #picker5></mat-datepicker>
      </mat-form-field>
      in&nbsp;
      <mat-form-field>
        <input formControlName="location" matInput placeholder="Ort" />
      </mat-form-field>
      <h4>Veröffentlichung HPs</h4>
      <mat-form-field>
        <input formControlName="publishStart" matInput [matDatepicker]="picker6" placeholder="Veröffentlichung Start" />
        <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
        <mat-datepicker #picker6></mat-datepicker>
      </mat-form-field>
    </form>
  </form>
</div>
<div mat-dialog-actions>
  <markant-button mat-button color="secondary" (click)="cancel()">Abbrechen</markant-button>
  <span style="flex-grow: 100"></span>
  <markant-button mat-button color="secondary" color="primary" (click)="saveForm()"> {{ cycle ? 'Speichern' : 'Erstellen' }}</markant-button>
</div>
